import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import styles from "./header.module.css";
import { Mail, Menu, Phone, X } from "react-feather";
import { Dialog, DialogContent } from "@mui/material";
import { useWebsite } from "../../context/WebsiteContext";

function Header() {
  const navigate = useNavigate();
  const [fieldType, setFieldType] = useState("Email");
  const [emailValue, setEmailValue] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneValue, setPhoneValue] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [open1, setOpen] = useState(false);
  const [open21, setOpen21] = useState(false);
  const [smallMenu, setSmallMenu] = useState(false);
  const [trackBookingId, setTrackBookingId] = useState("");
  const [trackError, setTrackError] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  const goToTrackBooking = () => {
    setTrackError(false);
    if (trackBookingId === "") {
      setTrackError(true);
      return false;
    }
    setOpen21(false);
    navigate("/track-booking/" + trackBookingId);
  };

  const bookingModalClose = () => {
    setOpen(false);
  };

  const trackBookingModalClose = () => {
    setOpen21(false);
  };

  const goToBookingByEmail = () => {
    if (emailValue === "") {
      setEmailError("Please enter your email id.");
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(emailValue)) {
      setEmailError("Please enter valid email id.");
      return false;
    }
    let bookingData = { keyType: "email", keyValue: emailValue, activeStep: 0 };
    localStorage.setItem("bookingData", JSON.stringify(bookingData));
    setOpen(false);
    navigate("/make-booking");
  };

  const goToBookingByPhone = () => {
    if (phoneValue === "") {
      setPhoneError("Please enter your phone no.");
      return false;
    }

    let bookingData = { keyType: "phone", keyValue: phoneValue, activeStep: 0 };
    localStorage.setItem("bookingData", JSON.stringify(bookingData));
    setOpen(false);
    navigate("/make-booking");
  };

  const OpenSmallMenu = () => {
    setSmallMenu(!smallMenu);
  };

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const { currentDomain } = useWebsite();

  return (<div className={`${styles.Header} ${scrollPosition < 200 ? `${styles.noBackground}` : `${styles.stickyBackground}`}`}>
    <div className={`${styles.Container}`}>
      <div className={`${styles.HeadRow}`}>
        <div className={`${styles.HeadLogo}`}>
          <img src="/images/logo.svg" alt="logo" />
        </div>
        {!smallMenu && (<button className={`${styles.HambergerMenu}`} onClick={OpenSmallMenu}><Menu /></button>)}
        {smallMenu && (<button className={`${styles.HambergerMenu} ${styles.closeIcon}`} onClick={OpenSmallMenu}><X /></button>)}
        <div className={smallMenu === true ? `${styles.Menu} ${styles.open}` : `${styles.Menu}`}>
          <ul>
            <li>
              <Link to={"/"}>Home</Link>
            </li>
            <li>
              <Link to={"/contact-us"}>Contact Us</Link>
            </li>
          </ul>
          {currentDomain === process.env.REACT_APP_BASE_DOMAIN && <Link to={"/sign-up"} className={`${styles.HeadSignupBU}`}>Start free trial</Link>}
          <Link to={"/sign-in"} className={`${styles.HeadLoginBU}`}>Login</Link>
          <Link to={"/track-booking"} className={`${styles.HeadLoginBU}`}>Track</Link>
        </div>
      </div>
    </div>

    <Dialog
      open={open1}
      onClose={bookingModalClose}
      PaperProps={{ sx: { position: "fixed", top: 250 } }}
    >
      <DialogContent>
        <div className={`${styles.ModalBody}`}>
          <p className={`${styles.PopupHeading} ${styles.Heading}`}>Book Pickup And Delivery</p>

          <div>
            <div className={`${styles.Tabs}`}>
              <div className={fieldType === "Email" ? `${styles.TabCard} ${styles.Active}` : `${styles.TabCard}`} onClick={(e) => setFieldType("Email")}>
                <Mail /> <p>Email</p>
              </div>
              <div className={fieldType === "Phone" ? `${styles.TabCard} ${styles.Active}` : `${styles.TabCard}`} onClick={(e) => setFieldType("Phone")}>
                <Phone /> <p>Phone</p>
              </div>
            </div>
            {fieldType === "Email" && (<>
              <div className={`${styles.FormSec}`}>
                <input type="text" placeholder="Please enter your email" onChange={(e) => { setEmailValue(e.target.value); setEmailError(""); }} />
                <button type="button" onClick={goToBookingByEmail}>Submit</button>
              </div>
              {emailError !== "" && (<p className={`${styles.ErrorM}`}>{emailError}</p>)}
            </>)}
            {fieldType === "Phone" && (<>
              <div className={`${styles.FormSec} FormSec`}>
                <input type="text" placeholder="Please enter your phone" onChange={(e) => { setPhoneValue(e); setPhoneError(""); }} />
                <button type="button" onClick={goToBookingByPhone}>Submit</button>
              </div>
              {phoneError !== "" && (<p className={`${styles.ErrorM}`}>{phoneError}</p>)}
            </>)}
          </div>
          <button type="button" onClick={bookingModalClose} className={`${styles.ModalCloseBU}`}><X /></button>
        </div>
      </DialogContent>
    </Dialog>

    <Dialog
      open={open21}
      onClose={trackBookingModalClose}
      PaperProps={{ sx: { position: "fixed", top: 250 } }}
    >
      <DialogContent>
        <div className={`${styles.ModalBody}`}>
          <p className={`${styles.PopupHeading} ${styles.Heading}`}>Track your booking</p>
          <div className={`${styles.FormSec}`}>
            <input type="text" placeholder="Please enter your booking id" value={trackBookingId} onChange={(e) => setTrackBookingId(e.target.value)} />
            <button type="button" onClick={goToTrackBooking}>Submit</button>
          </div>
          {trackError && (<span style={{ color: "#ff0000", fontSize: "15px", lineHeight: "25px" }}>Please enter your booking id</span>)}
          <button type="button" onClick={trackBookingModalClose} className={`${styles.ModalCloseBU}`}><X /></button>
        </div>
      </DialogContent>
    </Dialog>
  </div>);
}

export default Header;